import { useQuery } from "@tanstack/react-query";
import { courseResourcesApi, CourseResourceTabApi, CourseResourceApi } from "./courseResourcesApi";
import { QUERIES_KEYS } from "queries";
import { ResourceTabIcon } from "pages/CourseResources/ClientIconsDropdown";

export interface ResourceFolder {
  name: string;
  resources: CourseResourceApi[];
  folderOrder: number;
}

export interface TabWithFolders {
  id: number;
  name: string;
  icon: ResourceTabIcon;
  folders: ResourceFolder[];
}

// Helper to group resources by folder
export const groupResourcesByFolder = (resources: CourseResourceApi[]): ResourceFolder[] => {
  const folderMap = new Map<string, CourseResourceApi[]>();

  for (const resource of resources) {
    const folderName = resource.folder ?? "Brak folderu"; // Default if folder is null
    if (!folderMap.has(folderName)) {
      folderMap.set(folderName, []);
    }
    folderMap.get(folderName)!.push(resource);
  }

  return Array.from(folderMap.entries()).map(([folderName, resources]) => ({
    name: folderName,
    resources,
    folderOrder: resources[0].folderOrder,
  }));
};

const mapToTabsWithFolders = (tabs: CourseResourceTabApi[]): TabWithFolders[] => {
  return tabs.map((tab) => ({
    id: tab.id,
    name: tab.name,
    icon: tab.icon,
    folders: groupResourcesByFolder(tab.resources),
  }));
};

export const useCourseResources = (courseId: number) => {
  const { data, isLoading } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_RESOURCES(courseId),
    queryFn: async () => {
      const response = await courseResourcesApi.getByCourseId(courseId);
      return mapToTabsWithFolders(response.data);
    },
  });

  return { tabs: data ?? [], isLoading };
};
